/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { Dropdown1 } from '../../content/dropdown/Dropdown1'
import { LanguageHelp } from '../../../helpers/LanguageHelper'
import ReactWordcloud from 'react-wordcloud'
import { DropdownFilterDate } from '../../../../_metronic/partials/content/dropdown/DropdownFilterDate'
import { Link } from 'react-router-dom'

type Props = {
  callbacks: {}
  words?: WordCloudDto[]
  className: string
  name?: string
  title?: string
  chartSize?: number
  functionSubmit?: any
  functionDownload?: any
  isDownloadContinue?: boolean
  height?: string
  warnings: { url: string, message: string }[]
  isWaringImageMirror?: boolean
}

export class WordCloudDto { text = ""; value = 0; positiveCount = 0; negativeCount = 0; neutralCount = 0; sentimentRate = 0; }

export const WordCloud: React.FC<Props> = ({
  callbacks,
  words = [new WordCloudDto],
  className,
  chartSize = 90,
  title = "",
  name = "",
  functionSubmit,
  functionDownload,
  isDownloadContinue = false,
  height = "250px",
  warnings = [],
  isWaringImageMirror = false
}) => {
  // const counter = React.useRef(0)
  // console.log("re-renderCount",counter.current++)
  return (

    <div className={`card ${className}`}>
      <div className='card-header pt-5'>
        <div className='card-title d-flex flex-column'>
          <span className='card-label fw-bold text-dark'>{title}</span>
          <div>
            <span className='text-gray-400 fw-semibold fs-6'>{name}:</span>
            {words![0].text !== "" && words.length !== 1 &&
              <div style={{ display: 'unset' }}>
                <span className='card-label fw-bolder text-gray-700 mt-2 pt-1'> {words?.length}</span>
              </div>
            }
          </div>
        </div>
        <div className='card-toolbar'>
          <DropdownFilterDate className='me-2 mb-2' functionSubmit={functionSubmit} />
          <button
            type='button'
            className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary mb-2'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
            onClick={(e) => { functionDownload() }}
            disabled={isDownloadContinue}
          >
            {!isDownloadContinue && (
              <KTSVG
                path='/media/icons/duotune/arrows/arr044.svg'
                className='svg-icon-3'
              />
            )}
            {isDownloadContinue && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>

      {words![0].text === "" &&
        <div className='card-body pt-2 pb-4 d-flex flex-wrap align-items-center'>
          <div className='d-flex flex-center me-5 pt-2'>
            <span className='indicator-progress' style={{ display: 'block', margin: 'auto' }}>
              {/* Please wait...{' '} */}
              <span className='spinner-border spinner-border-lg align-middle ms-2'></span>
              <div
                style={{ minWidth: chartSize + 'px', minHeight: chartSize + 'px' }}
              ></div>
            </span>
          </div>
        </div>
      }

      {(words![0].text !== "" && words!.length === 1) && (
        <div className='text-center p-11'>
          {warnings.map((warning, key) => (
            <Link key={key} to={warning.url}>
              <div>
                {warning.message}
                &nbsp;<KTSVG path='/media/icons/duotune/arrows/arr095.svg' className='svg-icon-2' />
              </div>
            </Link>
          ))}
          <div>
            <img
              className='mw-100 mh-200px'
              alt='metronic'
              style={{ transform: isWaringImageMirror ? 'scaleX(-1)' : 'scaleX(1)' }}
              src={toAbsoluteUrl('/media/illustrations/sketchy-1/1.png')}
            />
          </div>
        </div>
      )}

      {words![0].text !== "" && words.length !== 1 && (
        <div className='card-body pt-2 pb-4 d-flex flex-wrap align-items-center' style={{ minHeight: height }}>
          <div style={{ width: "100%", height: "100%" }}>
            <ReactWordcloud
              callbacks={callbacks}
              options={{
                rotations: 2,
                rotationAngles: [-90, 0],
                fontSizes: [20, 100],
                enableOptimizations: true,
                scale: "linear",
                deterministic: true,
                spiral: "archimedean",
              }}
              minSize={[parseInt(height),parseInt(height)]}
              words={words as any[]}
            />
          </div>
        </div>
      )}

    </div>
  )
}
